
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Outlet } from "react-router-dom"
import Navbar from "../pages/mainPages/Navbar"
import { getToken } from "../storage/LocalStorageService"

const ProfileLayout = () => {
  const { access_token } = getToken()
  const navigate = useNavigate()

  useEffect(() => {
    if (!access_token) {
      navigate("/auth/login")
    }
  }, [access_token, navigate])

  return (
    <div className="flex flex-col h-screen">
      <Navbar />
      <div className="flex flex-1 overflow-hidden">
        <div className="flex-1 p-4 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default ProfileLayout
